export class BarChartOptions {
    series: any = {
        stack: true,
        bars: {
            show: true,
            barWidth: 69120000,//60*60*1000*24 was (86400000)
            align: "center",
            lineWidth: 0
        },
        points: {
            show: true,
            radius: 0,
            symbol: 'square'
        }
    };
    xaxis: any = {
        mode: "time"
        , timeformat: "%d/\n%m/%y"
    };
    yaxis: any;
    grid: any = {
        hoverable: true,
        clickable: true,
        borderWidth: 0
    };
    legend: any;
    legendSelector: string;
    colors: any[];
    tooltip_top: number = -85;
    tooltip_left: number = 20;
    roundTooltip: boolean = false;
    tooltipCurrency: string = '';

    public getTooltipLeft(window: any): number {
        let leftOffset = 0;
        if ($(window).width() < 500) leftOffset = 15;
        if ($(window).width() >= 500 && $(window).width() < 960) leftOffset = 10;
        if ($(window).width() >= 960 && $(window).width() < 1400) leftOffset = 15;
        if ($(window).width() >= 1400) leftOffset = 15;
        return leftOffset;
    }

    // Format is $0.00
    public getMonetaryShortFormat(val, axis): string {
        return "$" + Math.round(val.toFixed(2));
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/chart/bar-chart-options.model.ts